<template>
  <div class="container">
    <button
      type="button"
      class="btn btn-info btn"
      @click="dialogVisible =!dialogVisible"
    >Create Role</button>
    <tabulator-card
      id="theMainTableBoxMyInvestments"
      :tableData="myRoles.data"
      :tableOptions="myRoles.options"
      :tableColumns="myRoles.columns"
    ></tabulator-card>
    <el-dialog title="Create Role" :visible.sync="dialogVisible" width="50%">
      <form class="container">
        <div class="form-group">
          <label>Role Name</label>
          <input type="texr" class="form-control" v-model="roleName" placeholder="Enter Role Name" />
        </div>
        <button type="submit" @click="sendInvite" class="btn btn-info btn-fill">Save</button>
      </form>
    </el-dialog>
  </div>
</template>
<script>
import Tabulator from "tabulator-tables";
import { TabulatorCard } from "src/components/index";
import { Select, Option, Dialog } from "element-ui";

export default {
  components: {
    TabulatorCard,
    [Dialog.name]: Dialog
  },
  computed: {
    roleData() {
      return this.$store.getters["role/role"];
    },
    myRoles() {
      let self = this;
      return {
        data: self.roleData,
        options: {
          layout: "fitColumns",
          tooltips: true,
          pagination: "local",
          paginationSize: 12,
          paginationSizeSelector: true,
          tooltipsHeader: true,
          initialSort: [{ column: "name", dir: "desc" }],
          rowClick: function(e, row) {
            self.handleEditInvestment(row.getData());
            e.preventDefault();
            return false;
          }
        },
        columns: this.investmentTableColumns
      };
    },
    investmentTableColumns() {
      const self = this;
      return [
        {
          title: "Name",
          field: "name",
          sorter: "string",
          resizable: true
        },
        {
          title: "Permissions",
          field: "permission",
          sorter: "String",
          resizable: true
        }
      ];
    }
  },
  data() {
    return {
      dialogVisible: false,
      roleName: ""
    };
  },
  methods: {
    sendInvite(e) {
      e.preventDefault();
    }
  },
  mounted() {
    this.$store.commit("role/role", {});
  }
};
</script>
<style>
</style>